import { ColumnsType } from 'antd/lib/table';

// eslint-disable-next-line
function getTableScrollX(columns: ColumnsType<any>) {
  return columns.reduce((prev, curr) => {
    const w = curr.width as number;

    return prev + w;
  }, 0);
}

export default getTableScrollX;
